module.exports = __webpack_public_path__ + "c6a34dffc30abf0609b27be08e4398ef.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/mug-white-design.png
// module id = 680
// module chunks = 0